.container {
  width: 100%;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  gap: 0.8rem;

  h3 {
    color: #8a8f98;
    font-weight: 600;
    font-size: 1.4rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* The colour was interpolated inside the nested `h3` rule, so the active
     variant has to target the child, not this element. */
  &[data-is-active='true'] h3 {
    color: #fff;
  }
}

.header-progress {
  display: flex;
  flex-direction: row;
  align-items: center;

  /* `gap` rather than a `> div:not(:last-child)` margin: the calendar's stage header puts a bare
     `<button>` in the `actions` slot, which that child-`div` selector would never space. */
  gap: 0.8rem;
}

.progress-indicator {
  font-size: 1.4rem;
  color: #8a8f98;
}

.stage-number {
  font-size: 1.4rem;
  color: #1f2023;
  border-radius: 0.4rem;
  background-color: #8a8f98;
  padding: 0.1rem 0.4rem;
  font-weight: 600;

  &[data-is-active='true'] {
    background-color: #fff;
  }
}
